import { tw } from "@careinfo/tailwind";
import FormCheckbox from "../Reusable/CheckBox";
import LocalCombobox from "../Reusable/LocalCombobox";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import TextField from "../Reusable/TextField";

const PartyForm = (props: any) => {
  const { control, register, errors, setValue, getValues, clearErrors, watch } =
    props;

  const accountData = [
    {
      id: "d4e5f6a7-8b9c-4d1e-2f3a-5b6c7d8e9f0a",
      name: "Sundry Creditors",
    },
    {
      id: "a17de76c-e2bf-4db1-9fbb-908002c43473",
      name: "Sundry Debtors",
    },
  ];

  return (
    <div className={tw`grid grid-cols-2 gap-x-2 px-4`}>
      <LocalCombobox
        data={accountData}
        errors={errors?.account}
        setValue={setValue}
        register={register("account")}
        name={"account"}
        clearErrors={clearErrors}
        value={getValues("account")}
        label={"Account Type"}
      />
      <TextField
        label="Account Name"
        control={control}
        name={"full_name"}
        placeholder=""
      />
      <TextField
        label="PAN/VAT"
        control={control}
        placeholder=""
        name={"vat_pan"}
      />
      <TextField
        label="Address"
        control={control}
        name={"address"}
        placeholder=""
      />
      <PhoneNumberField
        control={control}
        label={"Mobile Number"}
        name={"mobile_number"}
        errors={errors?.mobile_number}
      />
      <div className={tw`mt-2`}>
        <TextField
          label="Email"
          control={control}
          name={"email"}
          placeholder=""
        />
      </div>
      {/* <div className={tw`mt-2`}>
        <FormCheckbox
          name="is_supplier_customer"
          label="Both"
          register={register}
          watch={watch}
          setValue={setValue}
        />
      </div> */}
    </div>
  );
};

export default PartyForm;
